import { Component, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

// Made link with custom parent formControl
export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RgaaSelectComponent),
  multi: true
};

@Component({
  selector: 'app-rgaa-select',
  templateUrl: './rgaa-select.component.html',
  styleUrls: ['./rgaa-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})

export class RgaaSelectComponent implements ControlValueAccessor {

  // Props: Input
  @Input() options: Array<Object>;
  @Input() change: Function = (): any => false;
  @Input() select_id: string;

  // Props: Output
  @Output("OnChangeFunction") OnChangeFunction: EventEmitter<any> = new EventEmitter();

  // Properties
  public open: boolean = false;
  public selected_option: string = null;

  // ControlValueAccessor properties
  public innerValue: any = '';
  propagateChange = (_: any) => { };

  // ControlValueAccessor method : write
  writeValue(value: any): void {
    this.innerValue = value;
  }

  // ControlValueAccessor method : register on change
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  // ControlValueAccessor method : register on touched
  registerOnTouched(fn: any): void { }

  openOptionsList = (event): void => {
    event.stopPropagation();
    event.preventDefault();
    this.open = !this.open;
  }

  optionSelected = (option: string, event: Event): void => {
    event.stopPropagation();
    event.preventDefault();
    this.selected_option = option;
    this.OnChangeFunction.emit(this.selected_option);
    this.propagateChange(this.selected_option);
    this.open = !this.open;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/rgaa-select/rgaa-select.component.ts